{
    "FTP_PATH": "/gwjp/",
    "PLATFORM": "qjp",
    "LANGUAGE": "ja-JP",
    "EFE_ACTIVITY_HOST": "https://efe-activity-jp.aseugame.com/",
    "PF_HOST": "https://pf.efunjp.com/",
    "PF_WEB_HOST": "https://m.aseugame.com/",
    "IMG_HOST": "https://imgi.efunjp.com/",
    "LOGIN_HOST": "https://loginjp.aseugame.com/",
    "GAME_HOST": "https://gamejp.aseugame.com/",
    "LOGIN_WEB_PATH": "https://m.aseugame.com/enter/login?from=",
    "CDN_HOST": "https://resjp-download.vsplay.com/res_jp",
    "PLATFORM_GAME_CODE": "efunqjpplatform",
    "GAME_GPID": 1,
    "GAME_DEPT": 48,
    "PLATFORM_TYPE": "",
    "CODE_VERSION": "1.0",
    "gameCode": "jpjsjs",
    "activityCode": "jpjsjsPre"
}
